import React, { useState, useEffect } from 'react';
import Filter from './Filter'
import { Tick } from '../../icons/icons';

const FilterCheckboxes = ({name, label, isOpen, options, selectedValue, onCheck}) => {

  const [inputValues, setInputValues] = useState(selectedValue || [] );

  useEffect(() => {
    setInputValues(selectedValue || []);
  }, [selectedValue] );

  const onChangeHandler = e => {
    const value = e.target.value;
    let values = [...inputValues];

    if(inputValues.includes(value)) {
      values = values.filter((item)=> item !== value);
    } else {
      values.push(value);
    }

    setInputValues(values);
    onCheck(name, values);
  };

  return (
    <Filter label={label} isOpen={isOpen}>
      <div className="product-finder-aside__fieldset product-finder-aside__fieldset--cols">
        { options.map((input, index) => (
          <div key={index} className="product-finder-aside__checkbox-group form-item">
            <input
              id={`${input.label}${index}`}
              className="form-checkbox product-finder-aside__checkbox"
              type="checkbox"
              value={input.value}
              checked={inputValues.includes(input.value)}
              onChange={onChangeHandler} />
            <label htmlFor={`${input.label}${index}`}>
              {input.label}
              <Tick/>
            </label>
          </div>
        ))}
      </div>
    </Filter>
  );
};

export default FilterCheckboxes;
